import { render, staticRenderFns } from "./FaqSidebar.vue?vue&type=template&id=24c7ba1a"
import script from "./FaqSidebar.vue?vue&type=script&lang=js"
export * from "./FaqSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c7ba1a')) {
      api.createRecord('24c7ba1a', component.options)
    } else {
      api.reload('24c7ba1a', component.options)
    }
    module.hot.accept("./FaqSidebar.vue?vue&type=template&id=24c7ba1a", function () {
      api.rerender('24c7ba1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/FaqSidebar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FaqSidebar.vue
// module id = 129
// module chunks = 0